export const EVENT_OBSERVERS = {
  NAME: 'eventObserver',
  NAMESPACE: (name) => `eventObserver/${name}`,
  CLEAR: 'CLEAR',
  SET_SETTING: 'SET_SETTING',
  GET_SETTING: 'GET_SETTING',
  SET_EVENT_CAPTURE: 'SET_EVENT_CAPTURE',
  GET_EVENT_CAPTURES: 'GET_EVENT_CAPTURES',
}

export const state = {
  history: [],
  events: [],
  elements: [],
}

export const mutations = {
  [EVENT_OBSERVERS.CLEAR](state) {
    state.history = []
    state.events = []
    state.elements = []
  },
  [EVENT_OBSERVERS.SET_SETTING](state, { events, elements }) {
    state.events = events
    state.elements = elements
  },
  [EVENT_OBSERVERS.SET_EVENT_CAPTURE](state, { inside, type, touch }) {
    state.history.push({ inside, type, touch })
  },
}

export const getters = {
  [EVENT_OBSERVERS.GET_EVENT_CAPTURES](state) {
    return state.history
  },
  [EVENT_OBSERVERS.GET_SETTING](state) {
    return { events: state.events, elements: state.elements }
  },
}

export const actions = {
  [EVENT_OBSERVERS.CLEAR]({ commit, dispatch, getters }) {
    commit(EVENT_OBSERVERS.CLEAR)
  },
  [EVENT_OBSERVERS.SET_EVENT_CAPTURE]({ commit, dispatch, getters }, { inside, type, touch }) {
    commit(EVENT_OBSERVERS.SET_EVENT_CAPTURE, { inside, type, touch })
  },
  [EVENT_OBSERVERS.SET_SETTING]({ commit, dispatch, getters }, { events, elements }) {
    commit(EVENT_OBSERVERS.SET_SETTING, { events, elements })
  },
}
